import { CheckboxGroup as ChakraCheckboxGroup } from '@chakra-ui/react'

import { CheckboxGroupProps } from './CheckboxGroup.types'

export default function CheckboxGroup(props: CheckboxGroupProps) {
  return <ChakraCheckboxGroup {...props} />
}
